<div class="sticky-top">
	<nav
		[ngClass]="
			userProfile.darkMode ? 'navbar-dark bg-dark' : 'navbar-light'
		"
		class="navbar navbar-default navbar-expand-lg mat-elevation-z3"
	>
		<div class="container-fluid">
			<a class="navbar-brand" routerLink="#">
				<img
					[src]="
						'../../../../../assets/images/' +
						(userProfile.darkPercentage > 0.5
							? 'acciona_logo_white.svg'
							: 'acciona_logo.svg')
					"
					alt=""
					height="35"
					class="d-inline-block align-text-top"
				/>
			</a>
			<div class="d-flex header-margin-right">
				<button
					class="navbar-toggler"
					type="button"
					(click)="isMenuCollapsed = !isMenuCollapsed"
				>
					&#9776;
				</button>
				<div
					[ngClass]="
						userProfile.darkPercentage > 0.5
							? 'user-icon-white'
							: 'user-icon'
					"
					class="header-icon"
					(click)="emitProfile()"
					matTooltip="{{ userProfile?.name }}"
					matTooltipClass="tooltip-red"
				></div>
				<div
					[ngClass]="
						userProfile.darkPercentage > 0.5
							? 'logout-icon-white'
							: 'logout-icon'
					"
					class="header-icon"
					matTooltip="{{ 'header.toolbar.logout' | translate }}"
					matTooltipClass="tooltip-red"
				>
					<button mat-menu-item (click)="openLogOutDialog()"></button>
				</div>
			</div>
			<div
				[ngbCollapse]="isMenuCollapsed"
				class="collapse navbar-collapse"
			>
				<ul class="navbar-nav me-auto mb-2 mb-lg-0">
					<li
						class="nav-item"
						*ngFor="let link of HOME_MENU_ITEMS"
						[ngClass]="{
							disabled: link.active === true
						}"
					>
						<a
							class="nav-link"
							(click)="collapseMenu()"
							*ngIf="
								hasAccess(link) &&
								(link.external == null ||
									link.external == false)
							"
							[routerLink]="link.url"
							routerLinkActive="visited"
							>{{ link.text | translate }}</a
						>
						<!--           <a class="nav-link" (click)="collapseMenu();" *ngIf="hasAccess(link) && (link.external != null || link.external == true)" href="{{link.url}}/{{contextLocation.cebe | uppercase}}" target="_blank">{{ link.text | translate }}</a>
 -->
					</li>
				</ul>
				<form class="matauto-form">
					<div class="matauto-group">
						<input
							class="matauto-input"
							placeholder="{{
								'header.toolbar.imLookingFor' | translate
							}}"
							matInput
							aria-label="Escribir para filtrar"
							[matAutocomplete]="autoFilter"
							[formControl]="this.stateCtrl"
							[value]="currentFilter"
							(ngModelChange)="onSearch($event)"
						/>
						<img
							class="matauto-input-icon"
							width="24"
							height="24"
							[src]="
								'../../../../assets/icons/' +
								(userProfile.darkPercentage > 0.5
									? 'search.svg'
									: 'search_black.svg')
							"
						/>
						<mat-autocomplete
							class="mt-1"
							#autoFilter="matAutocomplete"
							[displayWith]="displayFn"
							(optionSelected)="placeSelected($event)"
						>
							<mat-option
								*ngFor="
									let place of this.filteredPlaces
										| async
										| slice : 0 : 50
								"
								[value]="this.place.url"
							>
								<div class="option-container">
									<img
										class="matauto-option-img"
										aria-hidden
										[src]="place.icon"
										height="25"
									/>
									<div class="option-text-container">
										<span class="option-name">
											<span
												*ngIf="
													place.id && place.id != ''
												"
												class="option-code"
												>{{ place.code }}</span
											>
											<span
												[innerHTML]="
													place.name
														| highlightSearch
															: currentFilter
												"
											></span>
										</span>
										<span
											class="option-type"
											[innerHTML]="
												place.typeNameTranslation
													| highlightSearch
														: currentFilter
											"
										></span>
									</div>
								</div>
							</mat-option>
						</mat-autocomplete>
					</div>
					<div
						style="display: none"
						[ngClass]="
							isFavPage
								? 'header-icon fav'
								: userProfile.darkPercentage > 0.5
								? 'header-icon star-white'
								: 'header-icon unfav'
						"
						matTooltip="{{
							'header.toolbar.favorites.name' | translate
						}}"
						matTooltipClass="tooltip-red"
						[matMenuTriggerFor]="favMenu"
					>
						<mat-menu
							#favMenu
							xPosition="before"
							class="optionMenuFav"
						>
							<div
								class="separator-bottom"
								mat-menu-item
								*ngIf="!isFavPage"
								(click)="this.savePageFav()"
							>
								<mat-icon
									class="fav-icon"
									aria-hidden="false"
									aria-label="fav"
									fontIcon="add_circle"
								></mat-icon>
								{{ "header.toolbar.favorites.add" | translate }}
							</div>
							<div
								mat-menu-item
								*ngIf="isFavPage"
								(click)="this.deletePageFav()"
							>
								<mat-icon
									class="fav-icon"
									aria-hidden="false"
									aria-label="unfav"
									fontIcon="remove_circle"
								></mat-icon>
								{{
									"header.toolbar.favorites.delete"
										| translate
								}}
							</div>
							<div class="separator-bottom fav-menu-title">
								<mat-icon
									class="fav-icon"
									aria-hidden="false"
									aria-label="star"
									fontIcon="star"
								></mat-icon>
								<h6>
									{{
										"header.toolbar.favorites.myPages"
											| translate
									}}
								</h6>
							</div>
							<div class="favPageRouter fav-options-container">
								<div
									*ngFor="let favPage of this.favPageList"
									class="nav-link"
								>
									<a
										class="favPageRouter fav-option-container"
										routerLink="{{ favPage.url }}"
									>
										<div class="option-text-container">
											<span class="option-name">{{
												favPage.name
											}}</span>
											<span class="option-type">{{
												favPage.location
											}}</span>
										</div>
									</a>
								</div>
							</div>
						</mat-menu>
					</div>
				</form>
			</div>
		</div>
	</nav>
	<!-- <nav
    [ngClass]="userProfile.darkMode ? '' : 'mat-elevation-z1'"
    class="navbar gray-transparency-50 navbar-default navbar-expand-sm breadcrumb-bar"
    aria-label="breadcrumb"
  >
    <div class="container-fluid">
      <ol class="breadcrumb mb-0 d-none d-md-flex">
        
        <li class="breadcrumb-item" *ngFor="let link of this.migas">
          <a href="{{ link.url }}"
            ><i
              *ngIf="link.nombre == 'header.menu.home.home'"
              class="fa fa-home"
            ></i>
            <i
              *ngIf="link.nombre == 'header.menu.home.map'"
              class="fa fa-map"
            ></i>
            <i
              *ngIf="link.nombre == 'header.menu.home.powerbi'"
              class="fa fa-bar-chart"
            ></i>
            <i
              *ngIf="link.nombre == 'header.menu.home.admin'"
              class="fa fa-lock"
              aria-hidden="true"
            ></i
            >{{ link.nombre | translate }}</a
          >
        </li>
      </ol>
      <ol class="breadcrumb mb-0 d-md-none">
        <li class="breadcrumb-item" *ngFor="let link of this.migas">
          <a title="{{ link.nombre }}" href="{{ link.url }}"
            ><i
              *ngIf="link.nombre == 'header.menu.home.home'"
              class="fa fa-home"
            ></i>
            <i
              *ngIf="link.nombre == 'header.menu.home.map'"
              class="fa fa-map"
            ></i>
            <i
              *ngIf="link.nombre == 'header.menu.home.powerbi'"
              class="fa fa-bar-chart"
            ></i>
            <i
              *ngIf="link.nombre == 'header.menu.home.admin'"
              class="fa fa-lock"
              aria-hidden="true"
            ></i
            >...</a
          >
        </li>
      </ol>
    </div>
  </nav> -->
</div>
